import { IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonCol, IonRow } from '@ionic/react';
import React, { useEffect, useState } from 'react';
import { Language } from '../../app/common/constants';
import ApplySign from '../controls/applySign';
import { procurementDisclosureEN, procurementDisclosureSP } from './services/procurementDisclosure';
import './css/concent.css';

function ProcurementDisclosure(props) {
    const [language, setLanguage] = useState("English");
    const [concent, setConcent] = useState(procurementDisclosureEN);

    useEffect(() => {
        if (props.language) {
            setLanguage(props.language);
        }
    }, [props.language]);

    useEffect(() => {
        if (language === Language.SPANISH) {
            setConcent(procurementDisclosureSP);
        }
        else {
            setConcent(procurementDisclosureEN);
        }
    }, [language]);

    const onSigned = (value) => {
        props.onSigned && props.onSigned(value);
    };

    return (
        <IonCard>
            <IonCardHeader>
                <IonCardTitle>{concent.title}</IonCardTitle>
            </IonCardHeader>

            <IonCardContent>

                <IonRow>
                    <IonCol>
                        <p>
                            {concent.content[0].data}
                        </p>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol>
                        <p>
                            {concent.content[1].data}
                        </p>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol>
                        <p className="font-weight-bold">
                            {concent.content[2].data}
                        </p>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol>
                        <p>
                            {concent.content[3].data.replace("###name###", props.name)}
                        </p>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol>
                        <p>
                            {concent.content[4].data}
                        </p>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol size="6">
                        <p className="concent-label">
                            {concent.content[5].data}
                        </p>
                        <p className="concent-label-value">
                            {props.name}
                        </p>
                    </IonCol>
                    <IonCol size="6">
                        <p className="concent-label">
                            {concent.content[6].data}
                        </p>
                        <p className="concent-label-value">
                            {props.dateOfBirth}
                        </p>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol size="6">
                        <p className="concent-label">
                            {concent.content[7].data}
                        </p>
                        <p className="concent-label-value">
                            {props.email}
                        </p>
                    </IonCol>
                    <IonCol size="6">
                        <p className="concent-label">
                            {concent.content[8].data}
                        </p>
                        <p className="concent-label-value">
                            {props.ssn}
                        </p>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol>
                        <p className="concent-label">
                            {concent.content[9].data}
                        </p>
                        <p className="concent-label-value">
                            {props.address}
                        </p>
                    </IonCol>
                </IonRow>

                <IonRow>
                    <IonCol size="6">
                        <p className="concent-label">
                            {concent.content[10].data}
                        </p>
                        <ApplySign
                        buttonText = {language && language == "Spanish" ? "Firma" :  "Sign"}
                            signed={props.signed}
                            signature={props.signature}
                            onSigned={(value) => onSigned(value)} />

                    </IonCol>
                </IonRow>
            </IonCardContent>
        </IonCard>
    );
}

export default ProcurementDisclosure;